module.exports = __webpack_public_path__ + "img/Terragrim_demo.9519f1fe.gif";